import AnalyticsEngineBase from "./../analyticsenginebase";
import * as eventNames from "./../analyticsevents";

export default class AnalyticsEngineCIMBase extends AnalyticsEngineBase {
  constructor(analyticsManager, options = {}) {
    super(analyticsManager, options);

    this._subscribeToEvents();
  }

  _subscribeToEvents() {
    this._subscribeToPageViews();
  }

  _subscribeToPageViews() {
    this._analyticsManagerBase.on(eventNames.VIEW_PAGE, (data) => {
      this.sendPageView(data);
    });
    this._analyticsManagerBase.on(
      eventNames.VIEW_PAGE_IN_BACKGROUND,
      (data) => {
        this.sendPageView(data);
      }
    );

    this._analyticsManagerBase.on(eventNames.VIEW_ARTICLE_ALB, (data) => {
      this.sendALB(data);
    });
  }
}



// WEBPACK FOOTER //
// ./src/common/analytics/engines/analyticsEngineCIMBase.js